import { getTransform } from "./qaConfig"

const getLocation_CRUD_Config = {
  ...getTransform("dk_location_create_button"),
  ...getTransform("dk_location_list_delete_icon"),
  ...getTransform("dk_location_location_number_create_label"),
  ...getTransform("dk_location_location_number_create_error"),
  ...getTransform("dk_location_location_number_create_input"),
  ...getTransform("dk_location_location_number_edit_label"),
  ...getTransform("dk_location_location_number_edit_input"),

  ...getTransform("dk_location_location_name_create_label"),
  ...getTransform("dk_location_location_name_create_error"),
  ...getTransform("dk_location_location_name_create_input"),
  ...getTransform("dk_location_location_name_edit_label"),
  ...getTransform("dk_location_location_name_edit_input"),

  ...getTransform("dk_location_phone_number_create_label"),
  ...getTransform("dk_location_phone_number_create_input"),

  ...getTransform("dk_location_location_manager_create_label"),
  ...getTransform("dk_location_location_manager_create_input"),
  ...getTransform("dk_location_location_manager_create_error"),
  ...getTransform("dk_location_location_manager_edit_label"),

  ...getTransform("dk_location_email_address_create_label"),
  ...getTransform("dk_location_email_address_create_input"),
  ...getTransform("dk_location_email_address_edit_label"),
  ...getTransform("dk_location_email_address_edit_input"),

  ...getTransform("dk_location_assistant_manager_create_label"),
  ...getTransform("dk_location_assistant_manager_create_input"),
  ...getTransform("dk_location_assistant_manager_edit_label"),
  ...getTransform("dk_location_assistant_manager_edit_input"),

  ...getTransform("dk_location_location_manager_edit_label"),
  ...getTransform("dk_location_location_manager_edit_input"),

  ...getTransform("dk_location_geographic_position_create_label"),
  ...getTransform("dk_location_geographic_position_edit_label"),

  ...getTransform("dk_location_phone_number_create_dropdown"),
  ...getTransform("dk_location_phone_number_edit_input"),
  ...getTransform("dk_location_phone_number_edit_label"),

  ...getTransform("dk_location_latitude_create_error"),
  ...getTransform("dk_location_latitude_create_input"),
  ...getTransform("dk_location_latitude_edit_input"),

  ...getTransform("dk_location_longitude_create_error"),
  ...getTransform("dk_location_longitude_create_input"),
  ...getTransform("dk_location_longitude_edit_input"),

  ...getTransform("dk_location_address_info_edit_label"),

  ...getTransform("dk_location_location_address_create_label"),
  ...getTransform("dk_location_location_address_create_input"),

  ...getTransform("dk_location_address_line1_create_error"),
  ...getTransform("dk_location_address_line1_create_input"),
  ...getTransform("dk_location_address_line1_edit_label"),
  ...getTransform("dk_location_address_line1_edit_input"),

  ...getTransform("dk_location_address_line2_create_label"),
  ...getTransform("dk_location_address_line2_create_input"),
  ...getTransform("dk_location_address_line2_edit_label"),
  ...getTransform("dk_location_address_line2_edit_input"),

  ...getTransform("dk_location_country_create_label"),
  ...getTransform("dk_location_country_create_input"),
  ...getTransform("dk_location_country_edit_label"),

  ...getTransform("dk_location_state_create_label"),
  ...getTransform("dk_location_state_create_input"),
  ...getTransform("dk_location_state_edit_label"),

  ...getTransform("dk_location_city_edit_label"),
  ...getTransform("dk_location_city_create_input"),
  ...getTransform("dk_location_city_edit_input"),
  ...getTransform("dk_location_zip_code_edit_input"),

  ...getTransform("dk_location_zip_code_edit_label"),
  ...getTransform("dk_location_zip_code_create_input"),

  ...getTransform("dk_location_time_zone_create_label"),
  ...getTransform("dk_location_time_zone_create_input"),
  ...getTransform("dk_location_open_date_create_label"),
  ...getTransform("dk_location_open_date_create_input"),
  ...getTransform("dk_location_close_date_create_label"),
  ...getTransform("dk_location_close_date_create_input"),

  ...getTransform("dk_location_type_select_key_label"),
  ...getTransform("dk_location_type_select_Input_label"),
  ...getTransform("dk_location_type_select_error"),
  ...getTransform("dk_location_type_select_Input"),

  ...getTransform("dk_location_type_locationsize_key_label"),
  ...getTransform("dk_location_type_locationsize_input_label"),

  ...getTransform("dk_location_type_locationsize_length_key_label"),
  ...getTransform("dk_location_type_locationsize_length_input"),
  ...getTransform("dk_location_type_locationsize_length_error"),

  ...getTransform("dk_location_type_locationsize_width_key_label"),
  ...getTransform("dk_location_type_locationsize_width_input"),
  ...getTransform("dk_location_type_locationsize_width_error"),

  ...getTransform("dk_location_type_locationsize_height_key_label"),
  ...getTransform("dk_location_type_locationsize_height_input"),
  ...getTransform("dk_location_type_locationsize_height_error"),

  ...getTransform("dk_location_services_select_input"),
  ...getTransform("dk_location_services_select_error"),

  ...getTransform("dk_location_attributes_select_name_input"),
  ...getTransform("dk_location_attributes_select_name_error"),
  ...getTransform("dk_location_attributes_select_value_input"),
  ...getTransform("dk_location_attributes_select_value_error"),
  ...getTransform("dk_location_attributes_select_add_button"),

  ...getTransform("dk_location_detailed_active_status_switch"),

  ...getTransform("dk_location_location_detailed_edit_icon"),
  ...getTransform("dk_location_location_detailed_cancel_icon"),
  ...getTransform("dk_location_location_detailed_check_circle_icon"),

  ...getTransform("dk_location_state_edit_input"),
  ...getTransform("dk_location_country_edit_input"),

  ...getTransform("dk_location_no_of_rooms_create_input"),
  ...getTransform("dk_location_no_of_rooms_create_label"),
  ...getTransform("dk_location_no_of_rooms_create_error"),
  ...getTransform("dk_location_no_of_rooms_edit_label"),
  ...getTransform("dk_location_no_of_rooms_edit_input")
}

const doAddOnOperationHoursTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-operation-hours-${testIdValue}`
  }

  return testId
}

const doAddOnEditOpenDateTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-location-edit-open-date-${testIdValue}`
  }

  return testId
}

const doAddOnMenuItemTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-dropdown-${testIdValue}`
  }

  return testId
}

const doAddOnEditOperatingHoursTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-location-edit-operating-hours-${testIdValue}`
  }

  return testId
}

const doAddOnEditLocationTypeTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-location-edit-location-type-${testIdValue}`
  }

  return testId
}

const doAddOnEditLocationServicesTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-location-edit-location-services-${testIdValue}`
  }

  return testId
}

const doAddOnEditLocationProductMappingTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-location-edit-location-product-mapping-${testIdValue}`
  }
  return testId
}

const doAddOnEditLocationDiscountTestId = (testIdValue = "null") => {
  let testId = {}
  if (testIdValue) {
    testId["data-testid"] = `dk-location-edit-location-discount-${testIdValue}`
  }
  return testId
}

export {
  getLocation_CRUD_Config,
  doAddOnOperationHoursTestId,
  doAddOnMenuItemTestId,
  doAddOnEditOpenDateTestId,
  doAddOnEditOperatingHoursTestId,
  doAddOnEditLocationTypeTestId,
  doAddOnEditLocationServicesTestId,
  doAddOnEditLocationProductMappingTestId,
  doAddOnEditLocationDiscountTestId
}
